import plur from "plur";
import * as z from "zod";

export const zodErrorMap = (issue: z.core.$ZodRawIssue) => {
  if (issue.code === "invalid_type") {
    return "Field is required";
  } else if (issue.code === "invalid_value") {
    return "Please select a valid option";
  } else if (issue.code === "invalid_format" && issue.format === "date") {
    return "Enter a valid date";
  } else if (issue.code === "too_small") {
    if (issue.origin === "string") {
      return `Field must have at least ${issue.minimum} ${plur("character", issue.minimum as number)}`;
    } else if (issue.origin === "array") {
      return `Please select at least ${issue.minimum} ${plur("value", issue.minimum as number)}`;
    }
  }

  return null;
};
